// Shared design tokens for the "New"-design field components
// (TextFieldCustomNew, SelectNew, AutocompleteNew) so their shared look
// — box chrome, label/value/placeholder/helper colors, dropdown menu style —
// stays a single source of truth instead of duplicated literals per file.
export const inputFieldTokens = {
  height: "32px",
  radius: "12px",
  border: "1px solid rgba(116,120,121,0.1)",
  background: "#fff",
  iconGap: "16px",
  colors: {
    label: "#605e5e",
    value: "#002129",
    placeholder: "#adaaaa",
    helper: "#747879",
  },
  menu: {
    marginTop: "4px",
    radius: "10px",
    border: "1px solid rgba(116,120,121,0.16)",
    shadow: "0px 4px 12px rgba(0,0,0,0.08)",
    optionPadding: "8px 12px",
    hoverBg: "rgba(117,162,176,0.08)",
    selectedBg: "rgba(117,162,176,0.08)",
    selectedHoverBg: "rgba(117,162,176,0.12)",
  },
  chevronSize: 16,
};
